import React from 'react'
import { Icon } from '../../../Icon'
import Terminal from '../../../Terminal'

export interface ToolCallProps {
  type: 'simple_tool_call'
  props: {
    relativeTime: string
    createdAt: string
    id: string
    name: string
    description: string
    args: Record<string, any>
    isLoading: boolean
    error?: string
  }
}

export type ToolCallComponent = {
  type: 'tool'
  props: ToolCallProps
}

export const ToolCall: React.FC<ToolCallProps> = ({ props }) => {
  const [isArgsVisible, setIsArgsVisible] = React.useState(false)
  const [isDescriptionExpanded, setIsDescriptionExpanded] =
    React.useState(false)

  return (
    <div className="flex flex-col py-2 px-4 whitespace-pre-wrap text-2xs w-full items-start justify-center gap-2">
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          {props.isLoading && (
            <Icon name="LoaderCircle" size={10} className="animate-spin" />
          )}
          {(() => {
            const content = (
              <>
                <div className="font-medium truncate max-w-[150px]">
                  {props.name}
                </div>
                {/* the description will display what the tool is currently doing */}
                <div
                  className={`text-muted-foreground underline decoration-dotted underline-offset-2 animate-pulse ${isDescriptionExpanded ? '' : 'truncate max-w-[300px]'}`}
                >
                  {props.description}
                </div>
              </>
            )

            return props.args ? (
              <button
                onClick={() => setIsArgsVisible(!isArgsVisible)}
                className="flex items-center gap-1 text-2xs text-muted-foreground hover:text-foreground transition-colors"
              >
                {content}
                <Icon
                  name={isArgsVisible ? 'ChevronDown' : 'ChevronRight'}
                  size={10}
                />
              </button>
            ) : (
              <span className="flex items-center gap-2">{content}</span>
            )
          })()}
        </div>

        {props.error && (
          <div className="flex items-center text-destructive text-2xs">
            <Icon name="CircleAlert" size={14} />
            {props.error}
          </div>
        )}
      </div>

      {props.args && (
        <div className="flex flex-col">
          {isArgsVisible && (
            <Terminal
              expandable={false}
              defaultExpanded={true}
              lines={[
                {
                  value: JSON.stringify(props.args),
                  date: new Date(),
                },
              ]}
            />
          )}
        </div>
      )}
    </div>
  )
}

export default ToolCall
